import { compact, flow, map } from 'lodash/fp';

import { Country, LocationResult } from '../../types';
import getIsMatch from '../get-is-match';

const getCountryMatch = (countries: Country[], searchTerm: string): LocationResult[] =>
  flow(
    map((country: Country) => {
      const hasMatchedCountry = getIsMatch(searchTerm, country.label);
      if (hasMatchedCountry) {
        const { region, id, label } = country;
        return { city: null, country: label, hasMatchedCountry, label, value: `${region}-${id}` };
      }
      return null;
    }),
    compact,
  )(countries) as LocationResult[];

export default getCountryMatch;
